// Online-order gate: decides whether this till polls getPendingOrderNotifications
// and whether it keeps the server websocket open.
//
// Only a till that takes aggregator (online) orders needs the poll: the popup it
// feeds is shown for UrbanPiper orders only. On live data (30 days to 2026-10-14)
// every till that received an online order had posConfig.enableAggregator "Y".
// The sale types are NOT a usable signal: the Masala Republic (Dadus) catalogues
// link only Take Away / Dine-In, yet those 9 tills received ~3,500 online orders.
//
// Fail open: while the config is not loaded (first load, before rehydration) the
// answer is "takes online orders", so a missed order is never the price of an
// unknown state.

// Till layouts that render a retail screen (PointOfSale/index.js): 1 retail,
// 3 kiosk, 4 market. Every other layout renders the restaurant screen, which reads
// the socket for tables, KOTs and mirror orders.
const RETAIL_LAYOUTS = [1, 3, 4];

export const parseTillLayout = (tillData) => {
  const raw = tillData?.tillAccess?.userAccessController;
  if (!raw) return null;
  try {
    const layout = parseInt(JSON.parse(raw)?.layout ?? 1, 10);
    return Number.isNaN(layout) ? null : layout;
  } catch (err) {
    console.warn("[onlineOrderGate] Could not read till layout:", err?.message);
    return null;
  }
};

// true = poll; false = this till takes no online orders.
export const tillTakesOnlineOrders = (posConfig) => {
  if (!posConfig) return true;
  return posConfig.enableAggregator === "Y";
};

// The restaurant screen always needs the live socket. A retail screen only for
// the online-order popup. An unknown layout keeps it (fail open).
export const tillNeedsLiveSocket = ({ tillLayout, takesOnlineOrders }) => {
  if (tillLayout === null || tillLayout === undefined) return true;
  if (!RETAIL_LAYOUTS.includes(tillLayout)) return true;
  return takesOnlineOrders !== false;
};
